module.exports = __webpack_public_path__ + "static/img/tec-know.af88a26.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/technology/tec-know.jpg
// module id = xfmF
// module chunks = 1